import React, {useState} from 'react';
import './Recovery.scss';
import { recoveryUser, validateErrorEmail, 
    closeRecoveryForm, clearErrorMessages, openLoginForm, openRecoveryPassForm } from '../authSlice';

import  { validateEmail }  from '../../../helper/validation';

const Recovery = (props) => {

    const {dispatch} = props;



    const [userInputMail, setUserInputMail]= useState('');
    const [errorValidation, setErrorValidation] = useState('');
       

  
    //CLICK SEND EMAIL
    const onSend = () => {
    
        const item = {
        email: userInputMail,
        }
        console.log("press send email recovery");
        dispatch(recoveryUser(item));
       // dispatch(closeRecoveryForm());
       // dispatch(openLoginForm());

    }


    
////////////////////////

    //CLOSE FORM
    const onClose = () => {
    
    dispatch(closeRecoveryForm());
    dispatch(openLoginForm());
    }

    // HANDLE EMAIL

    const handleUserInputMail = (e) => {
        
        const message = validateEmail(e.target.value);
        dispatch(validateErrorEmail(message));
        dispatch(clearErrorMessages());
        
        
        setUserInputMail(e.target.value);
        setErrorValidation(message);
    }
       
  
    let style;
        
    if ( !props.userData.errorMessageEmail && userInputMail) {
      
            style = ''
        } else {
            style = 'disabled'
    }

        return (
            <div className="Recovery">
              <h3>Восстановление пароля</h3>
               <div className='inputBlock'>
                    <input  type="email" placeholder="Электронная почта" required 
                        value={userInputMail} onChange={handleUserInputMail} />
                    
                  
               </div>

                <div className='errorBlock'>
                    <p className="error">{props.userData.errorMessageEmail}</p>
                    <p className="error">{props.userData.errorMessage}</p>
                    <p className="message">{props.userData.userMessageForRecovery}</p>
                    
                </div>

                <div className='buttonBlock'>
                    <button className='loginButton' onClick={onSend} disabled={style}>Отправить</button>
                    <button className='loginButton' onClick={onClose}>Отмена</button>
                    
                </div>

            </div>
        )
    
}
export default Recovery;
